/* eslint no-underscore-dangle: 0 */
import { Subject } from 'rxjs';

import {
  SocketIOMsgType,
  SocketIoEventMsg,
  SocketIoEntityMsg,
  JobEventBase,
} from 'Common/types';

export const PRODUCT_TOPIC = 'inventorum.api.apps.products.models.ProductModel';
export const USER_TOPIC = 'inventorum.api.apps.users.models.UserModel';
export const PRODUCTS_IMPORT_STATUS_UPDATE_TOPIC =
  'products.import.status_update';
export const PRODUCTS_IMPORT_PROGRESS_TOPIC = 'products.import.progress';

export const JOB_STATUS_UPDATE_EVENT = 'job.status_update';

interface SocketIoMsg<Data> {
  type: SocketIOMsgType;
  topic: string;
  data: Data;
}

export const SocketIOEvent = new Subject<
  SocketIoMsg<SocketIoEventMsg<unknown, unknown>>
>();
export const SocketIOEntity = new Subject<SocketIoMsg<SocketIoEntityMsg>>();

export const JobUpdate = new Subject<JobEventBase>();

export const publishSocketIoEventMsg = (data: SocketIoEventMsg) => {
  if (data.name === JOB_STATUS_UPDATE_EVENT) {
    return publishJobUpdateEvent(data);
  }
  return SocketIOEvent.next({ type: data._class, topic: data.name, data });
};

export const publishSocketIoEntityMsg = (data: SocketIoEntityMsg) =>
  SocketIOEntity.next({ type: data._class, topic: data.entity, data });

export const publishJobUpdateEvent = (data: SocketIoEventMsg) => {
  JobUpdate.next({
    id: data.fields.id,
    time_added: data.ts,
    state: data.fields.status,
    type: data.fields.type,
    result: data.fields.result,
    arguments: data.fields.arguments,
  });
};
